import { MainLayout } from 'shared/ui/layout/main';

import { BonusProgramsTabs } from '../tabs';

export function BonusProgramsLayout() {
  return <MainLayout tabs={<BonusProgramsTabs />} />;
}
